import styled from '@emotion/styled'

export const CardOnFileContainer = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 16px;
  font-family: 'Open Sans';
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-block: 16px;
  background: white;
`
export const CardOnFileTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  font-family: 'Open Sans';
  margin: 0;
`
export const CardOnFileDescription = styled.p`
  font-size: 14px;
  color: rgb(89, 96, 102);
  font-weight: 500;
  font-family: 'Open Sans';
  margin: 0;
`
export const CardOnFileBox = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 12px;
  background-color: rgb(250, 250, 250);
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const CardOnFileCardBox = styled(CardOnFileBox)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const CardOnFileNumber = styled.h4`
  font-size: 16px;
  font-weight: 700;
  font-family: 'Open Sans';
  margin: 0;
`
export const CardOnFileIcon = styled.img`
  height: 64px;
  width: auto;
`
export const CardOnFileCVCInput = styled.input`
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 8px;

  &:placeholder {
    color: rgb(89, 96, 102);
  }
`
export const CardOnFileLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  font-family: 'Open Sans';
  margin: 0;
`
export const CardOnFileActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`

export const CardOnFilePrimaryButton = styled.button`
  height: 35px;
  border-radius: 5px;
  padding-right: 20px;
  padding-left: 20px;
  border: 1px solid #ff5000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 12px;
  color: #ff5000;
  background: #ffffff;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:hover:not(:disabled) {
    background: #ff5000;
    color: #ffffff;
  }
`
export const CardOnFileSecondaryButton = styled.button`
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding-block: 12px;
  padding-inline: 16px;
  font-size: 14px;
  font-weight: 600;
  &:disabled {
    background-color: #dee2e6;
    cursor: not-allowed;
  }
`

export const SkeletonLoader = styled.div`
  height: 420px;
  width: 360px;
  background-color: #dee2e6;
  border-radius: 8px;
`
